/**
 * Admin host for the fully-editable interior execution plan — reuses the BV
 * ExecutionUnitDetail (which wraps ExecutionPlanPanel). All write actions are already
 * authorised for ZUMALE_USER on the backend, so the admin gets the same controls as BV.
 */
import React from "react";
import ExecutionUnitDetail from "../BV_user/ExecutionUnitDetail";

const InteriorExecutionDetailAdmin = () => (
  <ExecutionUnitDetail basePath="/zumale-admin/interior-executions" />
);

export default InteriorExecutionDetailAdmin;
